import { useEffect, useState } from 'react';
import { getAppFullName, getLogo } from '../utils/get-logo';

type LoadingStage = 'init' | 'auth' | 'workspace' | 'permissions';

const loadingMessages = {
  init: 'Cleaning up previous mess...',
  auth: 'Bribing the server gods...',
  workspace: 'Waking up from sleep mode...',
  permissions: 'Checking your clearance level...',
};

interface LoadingProps {
  stage?: LoadingStage;
}

export const Loading = ({ stage = 'init' }: LoadingProps) => {
  const [loadingDots, setLoadingDots] = useState('');

  // Animate loading dots
  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingDots((dots) => (dots.length >= 3 ? '' : dots + '.'));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex h-screen items-center justify-center flex-col" role="status" aria-label="Loading">
      <div className="flex flex-col items-center gap-4 animate-fadeIn">
        <img
          src={getLogo()}
          alt="Logo"
          className="h-12 w-12 animate-pulse"
          style={{ animationDuration: '1.5s' }}
        />
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-200">{getAppFullName()}</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 min-h-[20px]">
          {loadingMessages[stage]}
          {loadingDots}
        </p>
      </div>
    </div>
  );
};
